import maintenance from '../socket/maintenance';

const socketMaintenance = () => {
  maintenance.emit('init-web-data-session', { initWeb: 1 });

  maintenance.on('init-web-data-session', (data) => {
    if (data?.force && data.force === 'page') {
      window.location.reload();
    }
  });
};

export default socketMaintenance;
